var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-add modal-api-manager", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "modal-title" }, [
        _c("h4", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.dataApi ? "Edit" : "Add") + " API Manager")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap-content-modal" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-1",
              class: { "error-input": _vm.$v.dataSetup.name.$error }
            },
            [
              _c("label", [_vm._v(" API Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": false,
                  placeholder: "Input API Name"
                },
                model: {
                  value: _vm.dataSetup.name,
                  callback: function($$v) {
                    _vm.$set(_vm.dataSetup, "name", $$v)
                  },
                  expression: "dataSetup.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    class: { "error-input": _vm.$v.dataSetup.method.$error }
                  },
                  [
                    _c("label", [_vm._v(" Method ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      class: _vm.dataSetup.method,
                      attrs: {
                        options: _vm.methodOptions,
                        "error-required": false,
                        placeholder: "Select Method API",
                        label: "name"
                      },
                      model: {
                        value: _vm.dataSetup.method,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "method", $$v)
                        },
                        expression: "dataSetup.method"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-8 pl-0" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-1",
                    class: { "error-input": _vm.$v.dataSetup.url.$error }
                  },
                  [
                    _c("label", [_vm._v(" URL ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        "error-required": false,
                        placeholder: "Enter URL/Endpoint"
                      },
                      model: {
                        value: _vm.dataSetup.url,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "url", $$v)
                        },
                        expression: "dataSetup.url"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "api-tab" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "div",
                {
                  key: tab.id,
                  staticClass: "tab",
                  class: { active: tab.id === _vm.tabActive },
                  on: {
                    click: function($event) {
                      _vm.tabActive = tab.id
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
              )
            })
          ),
          _vm._v(" "),
          _vm.tabActive === "header"
            ? _c(
                "div",
                { staticClass: "api-header" },
                [
                  _vm._l(_vm.dataSetup.header, function(header, index) {
                    return _c(
                      "div",
                      { key: "header-" + index, staticClass: "header-list" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: header.name,
                              expression: "header.name"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Name" },
                          domProps: { value: header.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(header, "name", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: header.value,
                              expression: "header.value"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Value" },
                          domProps: { value: header.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(header, "value", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteHeader(index)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-header", on: { click: _vm.addHeader } },
                    [_vm._v("\n        + Add Header\n      ")]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabActive === "params"
            ? _c(
                "div",
                { staticClass: "api-header" },
                [
                  _vm._l(_vm.dataSetup.params, function(param, index) {
                    return _c(
                      "div",
                      { key: "header-" + index, staticClass: "header-list" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: param.variable,
                              expression: "param.variable"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Variable" },
                          domProps: { value: param.variable },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(param, "variable", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: param.value,
                              expression: "param.value"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Value" },
                          domProps: { value: param.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(param, "value", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash",
                          on: {
                            click: function($event) {
                              _vm.deleteParams(index)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-header", on: { click: _vm.addParams } },
                    [_vm._v("\n        + Add Params\n      ")]
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
            _c(
              "button",
              {
                staticClass: "button-border mr-2",
                on: {
                  click: function($event) {
                    _vm.$emit("close-modal")
                  }
                }
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c("button", { staticClass: "button-blue mr-2" }, [
              _vm._v("\n        Set\n      ")
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66a60341", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a60341","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/modal/modalApiManager.vue
// module id = null
// module chunks = 